import module from 'nominas/nomina/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('nominas.detalladoNomina', {
    url: '/nomina/:idEmpresa/:idNomina',
    abstract: true,
    resolve: {
      idProyecto: ($stateParams) => $stateParams.idEmpresa,
      idNomina: ($stateParams) => $stateParams.idNomina,
      nomina: (idProyecto, idNomina, NominasNomina) => NominasNomina.get(idProyecto, idNomina),
      title: (nomina) => `${nomina.ID_Nomina} ${+nomina.ID_Moneda === 1 ? 'MXN' : 'USD'}`,
      permisos: (idProyecto, idNomina, NominasNominaPermisos) => NominasNominaPermisos.get(idProyecto, idNomina),
    },
    data: {titleProxy: 'nominas.detalladoNomina.informacion'},
    template: '<nomina id-empresa="idProyecto" id-nomina="idNomina"></nomina>',
    controller: ($scope, idProyecto, idNomina) => {
      $scope.idProyecto = idProyecto
      $scope.idNomina = idNomina
    },
  })
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/routes/nomina.js